import { signalStore, withState } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { withSelectedEntity } from '../../../shared/store/selected-entity.feature';
import { Site } from '../model/site.model';
import { avecMéthodesSites } from './site.methods';
import { withPagination } from '@shared/store/pagination.feature';
import { initialState, SiteState } from './site.state';
import { avecSélecteursSites } from './site.selectors';

export const SiteStore = signalStore(
  { providedIn: 'root' },
  withEntities<Site>(),
  withState<SiteState>(initialState),
  withSelectedEntity(),
  withPagination<Site>(),
  avecSélecteursSites(),
  avecMéthodesSites(),
);
